import type { Edge, Node } from 'reactflow';
import {
  isFlowContentEqual as isFlowContentEqualShared,
  isNodeDataContentEqual as isNodeDataContentEqualShared,
} from '@duke-hq/shared-constants/contentDivergence';

// reactflow-typed wrappers over the shared normaliser, for the autosave gate and undo
// snapshots. See `@duke-hq/shared-constants/contentDivergence` for what's compared.

type FlowLike = {
  nodes: Node[];
  edges: Edge[];
  viewport?: unknown;
};

export function isFlowContentEqual(a: FlowLike, b: FlowLike): boolean {
  return isFlowContentEqualShared(a, b);
}

export function isNodeDataContentEqual(a: Node['data'], b: Node['data']): boolean {
  return isNodeDataContentEqualShared(a, b);
}
